import { c as _c } from "react/compiler-runtime";
import { type ContactsBlock as ContactsBlockData } from '../../../../utils/data/graphql/_generated/gql-generated';
import { type MembershipRequirementsBlockWithFallbacks } from '../../utils/helpers/add-fallbacks-to-membership-requirements-block';
import styles from './contacts-block.module.scss';
type ContactsBlockProps = {
  blockData: MembershipRequirementsBlockWithFallbacks;
};
export const ContactsBlock = t0 => {
  const $ = _c(4);
  const {
    blockData
  } = t0;
  const contacts = blockData.Contacts as ContactsBlockData[];
  let t1;
  if ($[0] !== contacts) {
    t1 = contacts.map(_temp);
    $[0] = contacts;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <div className={styles.contacts}>{t1}</div>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};
function _temp(contact) {
  const {
    Email: email,
    FaxNumber: fax,
    PhoneNumber: phone,
    RegionTitle: title
  } = contact.ContentLink?.Expanded as ContactsBlockData;
  return <div className={styles["contacts__contact-block"]} key={title}><div className={styles["contacts__region-title"]}>{title}</div>{phone && <div className={styles["contacts__contact-data"]}>Phone: <a href={`tel:${phone}`}>{phone}</a></div>}{fax && <div className={styles["contacts__contact-data"]}>Fax: <a href={`tel:${fax}`}>{fax}</a></div>}{email && <div className={styles["contacts__contact-data"]}><a href={`mailto:${email}`}>{email}</a></div>}</div>;
}